import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import userContext from "../context/UserContext";
import axios from "axios";

export default function Checkout() {
  const [sendingstatus, setsendingstatus] = useState(false);
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [address, setaddress] = useState("");
  const [city, setcity] = useState("");
  const [number, setnumber] = useState("");
  const [postalcode, setpostalcode] = useState("");
  const [email, setemail] = useState("");
  const [shippingMethod, setShippingMethod] = useState("delivery");
  const [errors, setErrors] = useState({});
  const [requestError, setRequestError] = useState(""); // NEW: visible network error

  const { user } = useContext(userContext);
  const navigate = useNavigate();

  const shippingPrice = 90;

  const validate = () => {
    const errs = {};
    if (!email.trim()) errs.email = "Ange din email.";
    else if (!/^\S+@\S+\.\S+$/.test(email)) errs.email = "Ogiltig emailadress.";

    if (!firstname.trim()) errs.firstname = "Ange ditt förnamn.";
    if (!lastname.trim()) errs.lastname = "Ange ditt efternamn.";
    if (!address.trim()) errs.address = "Ange din adress.";
    if (!city.trim()) errs.city = "Ange din stad.";

    const pc = (postalcode || "").replace(/\s+/g, "");
    if (!pc) errs.postalcode = "Ange postnummer.";
    else if (!/^\d{5}$/.test(pc)) errs.postalcode = "Ange ett giltigt postnummer (5 siffror).";

    const digits = (number || "").replace(/\D/g, "");
    if (!digits) errs.number = "Ange ditt telefonnummer.";
    else if (digits.length < 7) errs.number = "Telefonnumret verkar för kort.";

    if (!["delivery", "pickup_sodertalje", "pickup_orebro"].includes(shippingMethod)) {
      errs.shipping = "Välj ett leveransalternativ.";
    }

    // also ensure there are items
    if (!user || !Array.isArray(user.cartItems) || user.cartItems.length === 0) {
      errs.cart = "Kundvagnen är tom.";
    }

    return errs;
  };

  const safeCartItems = Array.isArray(user?.cartItems) ? user.cartItems : [];

  const calculateTotalPrice = () => {
    const booksTotal = safeCartItems.reduce(
      (total, item) => total + (item.discountedPrice || 0) * (item.quantity || 0),
      0
    );
    const shippingFee = safeCartItems.length > 0 && shippingMethod === "delivery" ? shippingPrice : 0;
    return booksTotal + shippingFee;
  };

 const placeorder = async (e) => {
  e.preventDefault();
  setRequestError("");
  setsendingstatus(true);
  console.log("Placing order…");

  const errs = validate();
  if (Object.keys(errs).length > 0) {
    setErrors(errs);
    setsendingstatus(false);
    return;
  }
  setErrors({});

  const totalPrice = calculateTotalPrice();
  const safeCartItems = Array.isArray(user?.cartItems) ? user.cartItems : [];

  const shippingAddress =
    shippingMethod === "delivery"
      ? "Till angiven adress vid utcheckning"
      : shippingMethod === "pickup_sodertalje"
      ? "Rosenhöjdsvägen 26, 15230 Södertälje"
      : "Spannmålsgatan 12, 70360 Örebro";

  const shippingFee =
    shippingMethod === "delivery" && safeCartItems.length > 0 ? 90 : 0;

  const preparedata = {
    firstname,
    lastname,
    address,
    city,
    number,       // <- telefonnummer is here
    email,
    postalcode,
    order: user,  // ensure your backend expects this shape
    totalPrice,
    shipping: {
      method: shippingMethod,
      label: shippingMethod === "delivery" ? "Frakt" : "Hämtning",
      address: shippingAddress,
      feeSek: shippingFee,
    },
    booksTotal: safeCartItems.reduce(
      (s, i) => s + (i.discountedPrice || 0) * (i.quantity || 0),
      0
    ),
  };

  try {
    // helpful debug: payload size
    const payloadStr = JSON.stringify(preparedata);
    console.log("Payload bytes:", new Blob([payloadStr]).size);

    const res = await axios.post(
      "https://kifo-backend.vercel.app/api/contact",
      preparedata,
      {
        headers: { "Content-Type": "application/json" },
        timeout: 15000,          // 15s: don’t hang forever
        withCredentials: false,  // normally false for public APIs
      }
    );

    console.log("Order response status:", res?.status);
    navigate("/order-confirmation");
  } catch (error) {
    console.error("Error placing order:", error);
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Ett fel uppstod vid beställningen. Försök igen.";
    setRequestError(msg);
  } finally {
    // ALWAYS re-enable button even if it hung or threw
    setsendingstatus(false);
  }
};


  const fieldClass = (hasError) =>
    `bg-[#F3F3F3] w-full h-[60px] text-[16px] outline-none px-4 rounded ${
      hasError ? "border border-red-500" : "border border-transparent"
    }`;

  return (
    <div>
      <div className="mx-auto grid grid-cols-2 lg:block w-[100%]">
        <div className="w-[100%] h-[100vh] p-5 lg:px-3 px-10 overflow-auto border-0">
          <form onSubmit={placeorder}>
            <div>
              <h1 className="text-[30px] sm:text-[22px] leading-18">
                Nedan finner du några fält som behöver fyllas i för att din beställning ska kunna gå igenom.
              </h1>
            </div>

            <div className="border-[1px] border-[#ddd] p-3 rounded-lg mt-4">
              <h1 className="font-bold">NOTERA!</h1>
              <p>För att du ska kunna få din beställning så fort som möjligt, fyll i alla fälten korrekt.</p>
            </div>

            {/* Request/network error banner */}
            {requestError && (
              <div className="mt-4 p-3 rounded bg-red-50 border border-red-200 text-red-700 text-sm">
                {requestError}
              </div>
            )}

            {/* Cart empty error */}
            {errors.cart && (
              <div className="mt-4 p-3 rounded bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm">
                {errors.cart}
              </div>
            )}

            <div className="mt-7 flex flex-col gap-7">
              {/* Email */}
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="email" className="text-[17px]">Email*</label>
                <input
                  type="email"
                  id="email"
                  className={fieldClass(!!errors.email)}
                  placeholder="Din Email*"
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                  aria-invalid={!!errors.email}
                  aria-describedby={errors.email ? "email-error" : undefined}
                />
                {errors.email && <small id="email-error" className="text-red-600">{errors.email}</small>}
                <small>Vi behöver Email för verifikation</small>
              </div>

              {/* Förnamn */}
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="fname" className="text-[17px]">Förnamn*</label>
                <input
                  type="text"
                  id="fname"
                  className={fieldClass(!!errors.firstname)}
                  placeholder="Ditt förnamn"
                  value={firstname}
                  onChange={(e) => setfirstname(e.target.value)}
                  aria-invalid={!!errors.firstname}
                  aria-describedby={errors.firstname ? "fname-error" : undefined}
                />
                {errors.firstname && <small id="fname-error" className="text-red-600">{errors.firstname}</small>}
              </div>

              {/* Efternamn */}
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="lname" className="text-[17px]">Efternamn*</label>
                <input
                  type="text"
                  id="lname"
                  className={fieldClass(!!errors.lastname)}
                  placeholder="Ditt efternamn"
                  value={lastname}
                  onChange={(e) => setlastname(e.target.value)}
                  aria-invalid={!!errors.lastname}
                  aria-describedby={errors.lastname ? "lname-error" : undefined}
                />
                {errors.lastname && <small id="lname-error" className="text-red-600">{errors.lastname}</small>}
              </div>

              {/* Adress */}
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="Address" className="text-[17px]">Adress*</label>
                <input
                  type="text"
                  id="Address"
                  className={fieldClass(!!errors.address)}
                  placeholder="Ange din adress"
                  value={address}
                  onChange={(e) => setaddress(e.target.value)}
                  aria-invalid={!!errors.address}
                  aria-describedby={errors.address ? "address-error" : undefined}
                />
                {errors.address && <small id="address-error" className="text-red-600">{errors.address}</small>}
              </div>

              {/* Stad */}
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="City" className="text-[17px]">Stad*</label>
                <input
                  type="text"
                  id="City"
                  className={fieldClass(!!errors.city)}
                  placeholder="Ange stad"
                  value={city}
                  onChange={(e) => setcity(e.target.value)}
                  aria-invalid={!!errors.city}
                  aria-describedby={errors.city ? "city-error" : undefined}
                />
                {errors.city && <small id="city-error" className="text-red-600">{errors.city}</small>}
              </div>

              {/* Postnummer */}
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="pc" className="text-[17px]">Postnummer*</label>
                <input
                  type="text"
                  id="pc"
                  className={fieldClass(!!errors.postalcode)}
                  placeholder="Postnummer (t.ex. 123 45)"
                  value={postalcode}
                  onChange={(e) => setpostalcode(e.target.value)}
                  aria-invalid={!!errors.postalcode}
                  aria-describedby={errors.postalcode ? "pc-error" : undefined}
                />
                {errors.postalcode && <small id="pc-error" className="text-red-600">{errors.postalcode}</small>}
              </div>

              {/* Telefonnummer */}
<div className="w-full flex flex-col gap-2">
  <label htmlFor="phone" className="text-[17px]">Telefonnummer*</label>
  <input
    type="tel"
    id="phone"
    className={fieldClass(!!errors.number)}
    placeholder="Telefonnummer"
    value={number}
    onChange={(e) => setnumber(e.target.value)}
    aria-invalid={!!errors.number}
    aria-describedby={errors.number ? "phone-error" : undefined}
  />
  {errors.number && (
    <small id="phone-error" className="text-red-600">{errors.number}</small>
  )}
</div>


              {/* Leveransalternativ */}
              <div className="w-full flex flex-col gap-2">
                <label className="text-[17px]">Leveransalternativ*</label>
                <div className="mt-1 flex flex-col gap-3">
                  <label className="flex items-start gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="shipping"
                      value="delivery"
                      checked={shippingMethod === "delivery"}
                      onChange={(e) => setShippingMethod(e.target.value)}
                    />
                    <span>
                      Frakta beställningen till adressen jag anger i utcheckningen{" "}
                      <span className="text-[#7A797B]">( +90 Kr )</span>
                    </span>
                  </label>
                  <label className="flex items-start gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="shipping"
                      value="pickup_sodertalje"
                      checked={shippingMethod === "pickup_sodertalje"}
                      onChange={(e) => setShippingMethod(e.target.value)}
                    />
                    <span>
                      Hämtar beställningen från Rosenhöjdsvägen 26, 15230 Södertälje{" "}
                      <span className="text-[#7A797B]">( 0 Kr )</span>
                    </span>
                  </label>
                  <label className="flex items-start gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="shipping"
                      value="pickup_orebro"
                      checked={shippingMethod === "pickup_orebro"}
                      onChange={(e) => setShippingMethod(e.target.value)}
                    />
                    <span>
                      Hämtar beställningen från Spannmålsgatan 12, 70360 Örebro{" "}
                      <span className="text-[#7A797B]">( 0 Kr )</span>
                    </span>
                  </label>
                </div>
                {errors.shipping && <small className="text-red-600">{errors.shipping}</small>}
              </div>

              {/* Total */}
              <div>
                <h2 className="font-bold text-[24px] text-[#2D251A] text-right">
                  Totalt: {calculateTotalPrice()} Kr
                </h2>
                {shippingMethod !== "delivery" ? (
                  <p className="text-right text-sm text-[#7A797B]">(Hämtning vald – ingen fraktavgift)</p>
                ) : (
                  <p className="text-right text-sm text-[#7A797B]">(Frakt inkl. 90 Kr)</p>
                )}
              </div>
            </div>

            <div className="mt-6">
              <button
                type="submit"  // IMPORTANT
                className="bg-[#2D251A] hover:bg-[#4d402e] text-[#fff] font-bold w-full h-[60px] text-[17px]"
                disabled={sendingstatus}
              >
                {sendingstatus ? "Vänligen vänta" : "Lägg order"}
              </button>
            </div>
          </form>
        </div>

        <div
          className="h-[100vh] lg:hidden relative bg-[#EFEFEF] bg-no-repeat bg-center w-full"
          style={{ backgroundImage: `url(https://cdn.pixabay.com/photo/2024/02/24/20/54/books-8594725_1280.jpg)` }}
        >
          <span className="w-full h-full bg-[#2d251a8b] absolute left-0 top-0"></span>
        </div>
      </div>
    </div>
  );
}
